import { render, staticRenderFns } from "./MyCompanyPaymentTypesNew.vue?vue&type=template&id=63522715&"
import script from "./MyCompanyPaymentTypesNew.vue?vue&type=script&lang=js&"
export * from "./MyCompanyPaymentTypesNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports